import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const AccountLoginDetailsComponent = ({ id, onInnerBasicFormChange, salutation, onInnerFormChange, selectedAccounts }: any) => (
  <>
    <AccordionContainer

      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Salutation"
            labelField="Text"
            list={salutation}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'UserInfo.Salutation',
                selectedAccounts?.UserInfo
              );
            }}
            optionName='Choose Salutation'
            type="select"
            value={selectedAccounts?.UserInfo?.Salutation}
            valueField="Value"
          />
          <InputContainer
            label="First Name"
            name="FirstName"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'UserInfo.FirstName',
                selectedAccounts?.UserInfo
              );
            }}
            type="text"
            value={selectedAccounts?.UserInfo?.FirstName}
          />
          <InputContainer

            label="Last Name"
            name="LastName"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'UserInfo.LastName',
                selectedAccounts?.UserInfo
              );
            }}
            type="text"
            value={selectedAccounts?.UserInfo?.LastName}
          />
        </div>
      }
      expandedPanel="userInfo"
      headerTitle="User Information"
    />
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            isDisabled={id !== '0'}
            label="Email"
            name="Email"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'LoginInfo.Email',
                selectedAccounts?.LoginInfo
              );
            }}
            type="text"
            value={selectedAccounts?.LoginInfo?.Email}
          />
          <InputContainer
            isDisabled={id !== '0'}
            label="PhoneNumber"
            name="PhoneNumber"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'LoginInfo.PhoneNumber',
                selectedAccounts?.LoginInfo
              );
            }}
            type="number"
            value={selectedAccounts?.LoginInfo?.PhoneNumber}
          />
          {id === '0' && (
            <InputContainer
              icon
              label="Password"
              name="Password"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'LoginInfo.Password',
                  selectedAccounts?.LoginInfo
                );
              }}
              type="password"
              value={selectedAccounts?.LoginInfo?.Password}
            />
          )}
          {id === '0' && (
            <InputContainer
              icon
              label="Confirm Password"
              name="ConfirmPassword"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'LoginInfo.ConfirmPassword',
                  selectedAccounts?.LoginInfo
                );
              }}
              type="password"
              value={selectedAccounts?.LoginInfo?.ConfirmPassword}
            />
          )}
        </div>
      }
      expandedPanel="loginInfo"
      headerTitle="Login Information"
    />
    {id !== '0' &&
      <AccordionContainer

        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer

              label="Active"
              name="IsActive"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event,
                  'IsActive'
                )
              }}
              type="checkbox"
              value={selectedAccounts?.IsActive}
            />
          </div>
        }
        expandedPanel="Deactivate Users"
        headerTitle="Deactivate Users"
      />}

  </>
)

export default AccountLoginDetailsComponent;
